// extracted by mini-css-extract-plugin
module.exports = {"specInnerRow":"az_IQc","specInnerRowV2":"az_JQc","specsCell":"az_KQc","compactCell":"az_LQc","specLabel":"az_MQc","specsValue":"az_NQc","specsCellV2":"az_OQc"};